/**
 * Returns the current time as a zero-padded `HH:mm` string.
 *
 * @param now - The date to extract the time from. Defaults to `new Date()`.
 */
export const getCurrentTime = (now = new Date()): string => {
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};
